import { CONFIGS } from '../../shared/config';

const VIETSEARCH_URL = CONFIGS.API_PREFIX;

export const ExpertApis = {
  homepage: `${VIETSEARCH_URL}/experts/homepage`,
};
